var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.layerClassName, style: _vm.layerStyle },
    _vm._l(_vm.layer.images, function (image) {
      return _c("div", { staticClass: "box_img" }, [
        image.linkUrl
          ? _c(
              "a",
              {
                staticClass: "link_thumb",
                attrs: { href: image.linkUrl, target: "_blank" },
              },
              [
                _c(
                  "div",
                  { staticClass: "wrap_img", style: _vm.wrapperStyle },
                  [
                    _c("img", {
                      class: _vm.imageClassName(image.imageUrl),
                      attrs: { src: image.imageUrl, alt: "" },
                      on: {
                        load: function ($event) {
                          return _vm.onLoad(image.imageUrl, $event)
                        },
                      },
                    }),
                  ]
                ),
              ]
            )
          : _c("div", { staticClass: "wrap_img", style: _vm.wrapperStyle }, [
              _c("img", {
                class: _vm.imageClassName(image.imageUrl),
                attrs: { src: image.imageUrl, alt: "" },
                on: {
                  load: function ($event) {
                    return _vm.onLoad(image.imageUrl, $event)
                  },
                },
              }),
            ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }